import { propClassName } from '@/styles/Spinner';
import type { ClassNameProp, ComponentPropsWithRef, ComponentWithRef } from '@/types/component';
import cn from 'lib/utils/cn';
import { forwardRef } from 'react';
import { SpinnerLoaderComponent } from './Spinner.Loader';

export interface SpinnerComponentProps extends ComponentPropsWithRef<'div'> {
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

const SpinnerComponent: ComponentWithRef<HTMLDivElement, SpinnerComponentProps> = forwardRef(
  ({ colors, size, variant, children, className, ...props }, ref) => {
    const colorClassName = propClassName('colors', colors, 'primary');
    const sizeClassName = propClassName('size', size);
    const variantClassName = propClassName('variant', variant);

    const componentClassName = cn(colorClassName, sizeClassName, variantClassName, className);

    return (
      <div className={componentClassName} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);

export const Spinner = Object.assign(SpinnerComponent, {
  Loader: SpinnerLoaderComponent,
});
